import { getUser, hasAuthenticationToken } from "../api/AuthApi";
import { MeetingAction } from "../data/MeetinAction";
import { Item } from "../data/ItemOfBusiness";
import { MeetingStatus } from "../data/MeetingStatus";
import { StatUserCount } from "../data/StatUserCount";
import { User } from "../data/User";

export interface SLinkState {
  user: User | null;
  meetingStatus: MeetingStatus | null;
  statUserCount: StatUserCount | null;
  youTubeVideoId: string;
  socketConnectionId: string;
  myObjection: MeetingAction | null;
  myAskToSpeak: MeetingAction | null;
  myPointOfOrder: MeetingAction | null;
  mySuggestAmendment: MeetingAction | null;
  // possibly not used below here
  role: UserRoles;
  itemStatus: BusinessItemStatus;
  meetingActions: MeetingAction[];
  connectionState: WebSocketState;
  /** Latest ItemsUpdated broadcast; seq increases with each one so screens can react to it. */
  itemsUpdate: { items: Item[]; deletedIds: string[]; seq: number } | null;
  /** Other organisers' open editors, from ItemEditing broadcasts (expire if not refreshed). */
  itemEditors: ItemEditor[];
}

export interface ItemEditor {
  subId: string;
  userId: string;
  name: string;
  /** Date.now() when last heard from */
  at: number;
}

export enum WebSocketState {
  Disconnected = "Disconnected",
  Connecting = "Connecting",
  Connected = "Connected",
}

export enum BusinessItemStatus {
  None = "None",
  Introduction = "Introduction",
  Discussion = "Discussion",
  ItemVote = "ItemVote",
  PointOfOrder = "PointOfOrder",
  Amendment = "Amendment",
  AmendmentVote = "AmendmentVote",
  MotionToVote = "MotionToVote",
}

export enum UserRoles {
  SuperAdmin = "SuperAdmin",
  Presenter = "Presenter",
  Admin = "Admin",
  OrganisationAdmin = "Organisation Admin",
  Organiser = "Organiser",
  Participant = "Participant",
  Observer = "Observer",
  None = "None",
}

export const initialSlState: SLinkState = {
  // loggedIn: hasAuthenticationToken(),
  user: null,
  socketConnectionId: "",
  role: UserRoles.None,
  itemStatus: BusinessItemStatus.None,
  meetingStatus: null,
  statUserCount: null,
  meetingActions: [],
  connectionState: WebSocketState.Disconnected,
  itemsUpdate: null,
  itemEditors: [],
  youTubeVideoId: "",
  myAskToSpeak: null,
  myObjection: null,
  myPointOfOrder: null,
  mySuggestAmendment: null,
};
